import React, { useEffect, useState } from "react";
import Image from "../../atoms/Image/Image";
import profilePic from "../../../assets/images/profile-pic.svg";
import { Link, useLocation } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../context/AuthContext";
import useRequest from "../../../context/useRequest";

const Sidebar = () => {
  const [userDetails, setUserDetails] = useState({});
  const { logout, userId } = useAuth();
  const { sendRequest } = useRequest();
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await sendRequest({
          method: "GET",
          url: `/auth/myProfile/${userId}`,
        });
        // Assuming response.data is an array
        if (response.status) {
          setUserDetails(response.data);
        }
      } catch (error) {
        console.error("Error fetching country codes:", error);
      }
    };

    fetchUserDetails();
  }, [sendRequest, userId]);

  const handleLogout = () => {
    logout();
  };
  return (
    <>
      <div className="sidebar">
        <div className="sidebar--profile ">
          <figure className="mb-0 sidebar--left-profile-image me-3">
            <Image src={profilePic} alt="profile" width="40" height="40" />
          </figure>
          <div className="sidebar--left-profile-content">
            <p className="mb-0">Hello,</p>
            <h5 className="mb-0 h5">
              {userDetails.first_name} {userDetails.last_name}
            </h5>
          </div>
        </div>
        <div className="sidebar--navigation">
          <ul className="sidebar--navigation-nav ">
            {/* <li className="sidebar--navigation-nav-list">
              <Link
                className={`sidebar--navigation-nav-list-link ${
                  currentPath === "/dashboard" ? "active" : ""
                }`}
                to="/dashboard"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M8.27042 22.7501H4.23041C2.22041 22.7501 1.25041 21.8201 1.25041 19.9001V4.10012C1.25041 2.18012 2.23041 1.25012 4.23041 1.25012H8.27042C10.2804 1.25012 11.2504 2.18012 11.2504 4.10012V19.9001C11.2504 21.8201 10.2704 22.7501 8.27042 22.7501ZM4.23041 2.75012C2.96041 2.75012 2.75041 3.09012 2.75041 4.10012V19.9001C2.75041 20.9101 2.96041 21.2501 4.23041 21.2501H8.27042C9.54042 21.2501 9.75041 20.9101 9.75041 19.9001V4.10012C9.75041 3.09012 9.54042 2.75012 8.27042 2.75012H4.23041Z" />
                  <path d="M19.7699 13.7501H15.7299C13.7199 13.7501 12.7499 12.8201 12.7499 10.9001V4.10012C12.7499 2.18012 13.7299 1.25012 15.7299 1.25012H19.7699C21.7799 1.25012 22.7499 2.18012 22.7499 4.10012V10.9001C22.7499 12.8201 21.7699 13.7501 19.7699 13.7501ZM15.7299 2.75012C14.4599 2.75012 14.2499 3.09012 14.2499 4.10012V10.9001C14.2499 11.9101 14.4599 12.2501 15.7299 12.2501H19.7699C21.0399 12.2501 21.2499 11.9101 21.2499 10.9001V4.10012C21.2499 3.09012 21.0399 2.75012 19.7699 2.75012H15.7299Z" />
                  <path d="M19.7699 22.7496H15.7299C13.7199 22.7496 12.7499 21.8196 12.7499 19.8996V18.0996C12.7499 16.1796 13.7299 15.2496 15.7299 15.2496H19.7699C21.7799 15.2496 22.7499 16.1796 22.7499 18.0996V19.8996C22.7499 21.8196 21.7699 22.7496 19.7699 22.7496ZM15.7299 16.7496C14.4599 16.7496 14.2499 17.0896 14.2499 18.0996V19.8996C14.2499 20.9096 14.4599 21.2496 15.7299 21.2496H19.7699C21.0399 21.2496 21.2499 20.9096 21.2499 19.8996V18.0996C21.2499 17.0896 21.0399 16.7496 19.7699 16.7496H15.7299Z" />
                </svg>

                <span>Dashboard</span>
              </Link>
            </li> */}
            <li className="sidebar--navigation-nav-list ">
              <Link
                className={`sidebar--navigation-nav-list-link ${["/profile", "/update-profile"].includes(currentPath) ? "active" : ""
                  }`}
                to="/profile"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9999 4.20005C9.90117 4.20005 8.19985 5.90137 8.19985 8.00005C8.19985 10.0987 9.90117 11.8 11.9999 11.8C14.0985 11.8 15.7999 10.0987 15.7999 8.00005C15.7999 5.90137 14.0985 4.20005 11.9999 4.20005ZM5.79985 8.00005C5.79985 4.57588 8.57569 1.80005 11.9999 1.80005C15.424 1.80005 18.1999 4.57588 18.1999 8.00005C18.1999 11.4242 15.424 14.2 11.9999 14.2C8.57569 14.2 5.79985 11.4242 5.79985 8.00005Z"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.49447 14.4947C7.21981 12.7693 9.55986 11.8 11.9999 11.8C14.4398 11.8 16.7799 12.7693 18.5052 14.4947C20.2306 16.22 21.1999 18.5601 21.1999 21C21.1999 21.6628 20.6626 22.2 19.9999 22.2C19.3371 22.2 18.7999 21.6628 18.7999 21C18.7999 19.1966 18.0834 17.467 16.8082 16.1917C15.5329 14.9165 13.8033 14.2 11.9999 14.2C10.1964 14.2 8.46678 14.9165 7.19153 16.1917C5.91628 17.467 5.19985 19.1966 5.19985 21C5.19985 21.6628 4.6626 22.2 3.99985 22.2C3.33711 22.2 2.79985 21.6628 2.79985 21C2.79985 18.5601 3.76914 16.22 5.49447 14.4947Z"
                  />
                </svg>
                <span>Profile</span>
              </Link>
            </li>
            <li className="sidebar--navigation-nav-list ">
              <Link
                className={`sidebar--navigation-nav-list-link ${currentPath === "/bookings-history" ? "active" : ""
                  }`}
                to="/bookings-history"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20.5983 11.6058V1.51181C20.5983 0.678427 19.9199 0 19.0865 0H1.51181C0.678427 0 0 0.678427 0 1.51181V17.1969C0 18.0302 0.678427 18.7087 1.51181 18.7087H10.9048C11.519 21.7238 14.1921 24 17.3858 24C21.033 24 24 21.033 24 17.3858C24 14.9035 22.6259 12.7369 20.5983 11.6058ZM0.755904 1.51181C0.755904 1.0951 1.0951 0.755904 1.51181 0.755904H19.0865C19.5032 0.755904 19.8424 1.0951 19.8424 1.51181V4.53542H0.755904V1.51181ZM1.51181 17.9528C1.0951 17.9528 0.755904 17.6136 0.755904 17.1969V5.29133H19.8424V11.2449C19.0827 10.9398 18.2531 10.7716 17.3858 10.7716C13.7386 10.7716 10.7716 13.7386 10.7716 17.3858C10.7716 17.5766 10.7801 17.7656 10.7961 17.9527L1.51181 17.9528ZM17.3858 23.2441C14.1554 23.2441 11.5275 20.6165 11.5275 17.3858C11.5275 14.1551 14.1551 11.5275 17.3858 11.5275C20.6165 11.5275 23.2441 14.1551 23.2441 17.3858C23.2441 20.6165 20.6165 23.2441 17.3858 23.2441Z" />
                  <path d="M20.3148 17.0077H18.6528C18.5252 16.5816 18.1888 16.2452 17.7636 16.1186V13.0393C17.7636 12.8305 17.5945 12.6614 17.3857 12.6614C17.1769 12.6614 17.0077 12.8305 17.0077 13.0393V16.1186C16.4616 16.282 16.0629 16.7875 16.0629 17.3857C16.0629 18.1151 16.6562 18.7085 17.3857 18.7085C17.9838 18.7085 18.4903 18.3098 18.6528 17.7636H20.3148C20.5237 17.7636 20.6928 17.5945 20.6928 17.3857C20.6928 17.1769 20.5236 17.0077 20.3148 17.0077ZM17.3858 17.9526C17.073 17.9526 16.8188 17.6984 16.8188 17.3856C16.8188 17.0729 17.073 16.8187 17.3858 16.8187C17.6985 16.8187 17.9527 17.0729 17.9527 17.3856C17.9527 17.6984 17.6985 17.9526 17.3858 17.9526Z" />
                  <path d="M16.4407 1.51171C15.8152 1.51171 15.3069 2.02006 15.3069 2.64557C15.3069 3.27107 15.8152 3.77942 16.4407 3.77942C17.0662 3.77942 17.5746 3.27107 17.5746 2.64557C17.5746 2.02006 17.0662 1.51171 16.4407 1.51171ZM16.4407 3.02352C16.2319 3.02352 16.0628 2.85438 16.0628 2.64557C16.0628 2.43675 16.2319 2.26761 16.4407 2.26761C16.6495 2.26761 16.8187 2.43675 16.8187 2.64557C16.8187 2.85438 16.6495 3.02352 16.4407 3.02352Z" />
                  <path d="M4.15735 1.51171C3.53185 1.51171 3.02349 2.02006 3.02349 2.64557C3.02349 3.27107 3.53185 3.77942 4.15735 3.77942C4.78285 3.77942 5.2912 3.27107 5.2912 2.64557C5.2912 2.02006 4.78285 1.51171 4.15735 1.51171ZM4.15735 3.02352C3.94853 3.02352 3.7794 2.85438 3.7794 2.64557C3.7794 2.43675 3.94853 2.26761 4.15735 2.26761C4.36617 2.26761 4.5353 2.43675 4.5353 2.64557C4.5353 2.85438 4.36617 3.02352 4.15735 3.02352Z" />
                  <path d="M2.74012 10.3935H5.76373C6.23239 10.3935 6.61412 10.0118 6.61412 9.54311V7.2754C6.61412 6.80674 6.23239 6.42501 5.76373 6.42501H2.74012C2.27146 6.42501 1.88973 6.80674 1.88973 7.2754V9.54311C1.88973 10.0118 2.27146 10.3935 2.74012 10.3935ZM2.64563 7.2753C2.64563 7.22333 2.68815 7.18081 2.74012 7.18081H5.76373C5.8157 7.18081 5.85822 7.22333 5.85822 7.2753V9.54301C5.85822 9.59498 5.8157 9.6375 5.76373 9.6375H2.74012C2.68815 9.6375 2.64563 9.59498 2.64563 9.54301V7.2753Z" />
                  <path d="M8.31494 11.1494H2.26771C2.05889 11.1494 1.88976 11.3185 1.88976 11.5273C1.88976 11.7362 2.05889 11.9053 2.26771 11.9053H8.31494C8.52376 11.9053 8.69289 11.7362 8.69289 11.5273C8.69289 11.3185 8.52376 11.1494 8.31494 11.1494Z" />
                  <path d="M6.42506 12.6612H2.26747C2.05865 12.6612 1.88952 12.8303 1.88952 13.0392C1.88952 13.248 2.05865 13.4171 2.26747 13.4171H6.42506C6.63388 13.4171 6.80301 13.248 6.80301 13.0392C6.80301 12.8303 6.63388 12.6612 6.42506 12.6612Z" />
                </svg>

                <span>Bookings History</span>
              </Link>
            </li>
            {/* <li className="sidebar--navigation-nav-list ">
              <Link
                className={`sidebar--navigation-nav-list-link ${currentPath === "/cancel-bookings" ? "active" : ""
                  }`}
                to="/cancel-bookings"
              >

                <svg width="24"
                  height="24"                  
                  fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-rtl-flip="true"><path d="M10.875 7.875a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0m1.5 0a4.875 4.875 0 1 0-9.75 0 4.875 4.875 0 0 0 9.75 0M1.5 20.25a6 6 0 0 1 12 0 .75.75 0 0 0 1.5 0 7.5 7.5 0 0 0-15 0 .75.75 0 0 0 1.5 0m18.852-10.125a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0m1.5 0a4.125 4.125 0 1 0-8.25 0 4.125 4.125 0 0 0 8.25 0m-5.78 5.647A4.776 4.776 0 0 1 22.5 20.25a.75.75 0 0 0 1.5 0 6.276 6.276 0 0 0-8.446-5.886.75.75 0 1 0 .518 1.408"></path></svg>

                <span>Cancel Bookings</span>
              </Link>
            </li> */}
          </ul>
        </div>
        <div className="sidebar--logout ">
          <button
            type="submit"
            onClick={handleLogout}
            className="sidebar--logout-buttom"
          >
            <span>Log out</span>
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
          </button>
        </div>
      </div>
    </>
  );
};
export default Sidebar;
